// extracted by mini-css-extract-plugin
export default {"priceContainer":"Hma-z","discountedPrice":"Ima-z","originalPrice":"Jma-z","productPrice":"Kma-z"};